export default "__VITE_ASSET__7MDMCKoP__"